const tasksData = [

    {
        id: `מנכ"ל / רמ"ט`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        'שיחת מנכ"ל ראש עיר וקביעת מסרים לציבור ומדיניות.',
                        'מתן הנחיה לפתיחת מרכז הפעלה רשותי והזעקת מספרי 1.',
                        "התייעצות משולשת ראש עיר, ר' אגף החינוך בחינת משמעויות לימודים והנחיות.",
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        "ביצוע שיחת ועידה עם מספרי 1 ומתן הנחיות ראשוניות להיערכות.",
                        'שיח עם מפקד הנפה / יקל"ר  מה האיום, צפי לירי, היקף אירועים צפויים.',
                        'הגדרת זמן ביצוע חיתוך מצב מעמ"ל רשותי והגדרת הנושאים להצגה בחיתוך המצב.'
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        "שיח ראש הרשות לתיאום הפעולות המיידיות בעת אירוע (מי יוצא, לאן יוצא).",
                        "אישור רשימת עובדים רשותית (מי מגיע פיזית, מי נותן שירות מהבית, מי שובץ היכן).",
                        "אישור רשימת מתנדבי החירום הרשותית, הקצאת המתנדבים למשימות ומי מקבל עדיפות."
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        "הגדרת סדר עדיפות משאבים לוגיסטיים רשותיים.",
                        'אישור תקציב לחירום וקביעת סדר עדיפות לשימוש במידת הצורך.',
                        'ביצוע  חיתוך מצב רשותי עם מספרי 1 סטטוס ביצוע מעמ"ל רשותי.',
                        'הפצת הודעה רשותית בדבר הפעלת צווי ריתוק לעובדים.'
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        'אישור רשימת משמרות בשולחן המרכזי וביצוע תדריך לבעלי התפקידים בשולחן.',
                        'ווידוא מימוש החלטות בהקשרי משאבים וכ"א בשטח.',
                        'ווידוא מוכנות יחידות המתנדבים והסע"ר לביצוע משימתם.',
                        'שיח מנהלים ועובדים בכירים להעברת תמונת מצב וציפיות.',
                        'תדריך מנהלי צוותי התערבות /  רובע / משימה רשותיים.'
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        'ביצוע תיאום מול מנכ"לי משרדי הממשלה ומס רכוש.',
                        'הושבת כלל מספרי 1 בשולחן המרכזי הרשותי ומוכנות לטפל באירועים.'
                    ]
                }
            ],

        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                'הכרזה על אירוע חירום – נפילה.',
                'גיבוש תמונת מצב, כולל המשאבים העיקריים הזמינים של הרשות, הצפת פערים ומציאת פתרונות עבורם.',
                'אישור מיקום פתיחת מס"ר. ',
                'הנחיה על פתיחת חפ"ק אחוד וניהולו מהשטח – חבירה לכוחות ההצלה, בניית תמונת מצב ראשונית ועדכון השולחן המרכזי. אם אין חפ"ק בשטח - חפ"ק רשותי תופס פיקוד עד להגעת המשטרה/ פקע"ר. ',
                'קבלת החלטה בנוגע לסיוע באמצעים לכוחות ההצלה, כגון: כלי צמ"ה/ אמצעי תאורה ועוד )בהתאם ליכולת הרשות(.',
                'הפצת הודעה ראשונית לתושבים בפלטפורמות הרלוונטיות ברשות.',
                `אישור מיקום אפשרי לחסרי קורת גג כולל האכלה, מים, הסעות ממקום האירוע וכו' ע"פ תיק משימות ייעודי.`,
                'הקמת צוות חשיבה - 24- 48 שעות קדימה כחלק מתוכנית מענה מתמשכת.'
            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                'החלטה על פתיחת מרכז סיוע ראשוני.',
                'מינוי מנהל מתקן סיוע ראשוני (מנכ"ל , רמ"ט, סגן, או דרג ניהולי בכיר).',
                'הגדרת צוותי משימה מכל מכלול לתפעול  מרכז הסיוע הראשוני.'
            ]
        },
        tasks4: {
            title: `סד"פ שגרת חירום`,
            tasks: [
                "מימוש שעון הפעילות הרשותי.",
                "וידוא עבודת המכלולים על פי הגדרות התפקיד.",
                'קיום סבב מנהלי מכלולים לגיבוש תמונת מצב פערים בקיום סד"פ שגרת חירום ע\"ב מערכת השוע\"ל.',
                "גיבוש תמונת מצב מתמשכת של העירייה בשולחן המרכזי.",
                "השתתפות מנהל המכלול בוועדה המייעצת לאוכלוסייה.",
                "קיום דיוני חשיבה לתכנון שבועי לטיפול באוכלוסייה.",
                "תחקור אירועים מרכזיים והפקת לקחים.",
                "גיבוש תמונת מצב מתמשכת של האוכלוסייה.",
                "ביצוע ביקורות שוטפות לכוח אדם, אמצעים ומערכות השו\"ב."
            ]
        }
    },

    {
        id: `מבצעים`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הפעלת נוהל אזעקת עובדים של המכלול ושל כלל מכלולי הרשות (במועצה אזורית צח"י, הרשות גדולה מנהלי רובעים).`,
                        `הפעלת נוהל קריאה למנהלי התאים, מנהלי הצוותים הייעודיים ועובדי המכלולים.`,
                        `קבלת תמונת מצב ראשונית ממשטרת ישראל/פיקוד העורף וארגוני חירום (משטרה, מד"א כב"ה).`,
                        `קריאה להפעלה של יחידות החילוץ/סע"ר ומתנדבים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `קבלת הנחיה מראש הרשות וביצוע פתיחת מקלטים והערכות על פתיחת מחסות המוניים והוצאת צו רשותי לפינוי מטלטלין.`,
                        `הנחיה לקב"טי מוס"ח באשר למדיניות ההתגוננות (בייחוד והאירוע מתרחש בזמן לימודים).`,
                        `פתיחת מרכז הפעלה רשותי ווידוא הגעת נציגי כלל המכלולים, בדיקת מערכות קשר , שו"ב ובדיקת כשירות גנרציה במרכז הפעלה וגנרטורים חירום נוספים.`,
                        `בניית שעון פעילות להמשך עם ראש העיר/מנכ"ל.`,
                        `תאום מול פקע"ר  - סד"כ גיוס, שטחי כינוס.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `התייצבות מפקדי יחידות החילוץ / סע"ר / צוותי אבטחה רשותיים לקבלת תדריך ראשוני.`,
                        `הכנת הערכת מצב עירונית (קבלת פרטים על האירועים ממשטרת ישראל/פקע"ר).`,
                        `החלטה על הפעלת זמן יקר.`,
                        `ווידוא מוכנות חפ"ק.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלולי.`,
                        `החלטה על סדר עדיפות פתיחת מתקני קליטה, מחסות המוניים, מרכזי קליטה.`,
                        `איסוף נתונים באשר למוכנות כלל צוותי החירום העירוניים (חילוץ, חפ"ק, הנדסה, אוכלוסייה, לוגיסטיקה).`,
                        `סיום גיוס צוותי חילוץ וסע"ר.`,
                        `עדכון כלל מנהלי המכלולים בדבר עיתוי הערכת המצב.`,
                        `קדם העמ"צ.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `ביצוע הערכת מצב עירונית וקבלת החלטה לאור מדיניות התגוננות: מוסדות חינוך, מקומות עבודה, התייצבות עובדים ברשות.`,
                        `פתיחת מחסני החירום וסיום בדיקת ציודם.`,
                        `מוכנות עם רשימות 2 משמרות במרכז ההפעלה.`,
                        `המשך אספקת שירותי אבטחה ברחבי הרשות באמצעות השיטור העירוני, סיורי המוקד הביטחון .`,
                        `סיום פתיחת מחסות המוניים ומתקן קליטה (במידה והוחלט על פתיחתו).`,
                        `וידוא יכולת עבודה בשתי משמרות לפחות ("שעון פעילות).`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `ריכוז רשימת המשמרות על פי מכלולים.`,
                        `תחילת עבודה ב"שעון פעילות" עירוני.`,
                        `ביצוע חיתוך מצב/הערכת מצב בהתאם לצורך.`,
                        `ביצוע מעקב ובקרה על הנחיות מנכ"ל / רמ"ט מהערכת מצב.`,
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `פתיחת יומן אירועים לתיעוד המידע באירוע. `,
                `עדכון ראש העיר/מנכ"ל, המכלולים ומטה רובע/ צח"י, וידוא התייצבות נציגי מכלולים במרה"פ וקבלת שמות נציגי המכלולים המאיישים את החפ"ק.`,
                `הוצאת סיור למקום האירוע- לאיתור מהיר של מקום הנפילה. `,
                `הוצאת חפ"ק לשטח האירוע וחבירה לארגוני החירום – לצד מנהל הזירה.`,
                `הפעלת יחידת חילוץ רשותית (כולל וידוא הגעת האמצעים והכלים). `,
                `גיבוש תמ"ץ רשותי מכלל המכלולים לכדי תמונת מצב אחידה באמצעות תא שולחן מרכזי. `,
                `קיום קשר ישיר עם כוחות הביטחון ופקע"ר לקבלת מידע ועדכונים שוטפים לטובת גיבוש תמ"ץ וכן לטובת דרישת / אספקת אמצעים. `,
                `פתיחת חפ"ק בסמוך למקום האירוע - העברת עדכונים שוטפים אל השולחן המרכזי במרה"פ.`,
                `וידוא ניהול צירי תנועה - חסימות לצורך מניעת כניסת רכב לשם פינוי צירי הגעת כוחות חילוץ למקום הנפילה והשארת צירי פינוי פתוחים סיוע למ"י ככל הנדרש.`,
                `יצירת קשר עם מטה הרובע/ צח"ש בו הזירה נמצאת (במוא"ז-צח"י), פתיחת שולחן מרכזי של הרובע להמשך ניהול האירוע.`,

            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `הכרזה על מיקום מרכז סיוע ראשוני לאחר החלטת ראש הרשות/ מנכ"ל.`,
                `עדכון הכוחות הרלוונטיים (כולל תיאום מענה מד"א לפצועים קל).`,
                `סדר ציבורי - העמדת אבטחה וסדרנות במקום בסיוע משטרת ישראל ויחידות פיקוח רשותיות.`,
                `ריכוז תמונת מצב והעברת הדרישות למטה החירום הרשותי.`,
                `ריכוז כלל הנתונים שנאספים במרכז (העברתם לגורמי חוץ ע"פ אישור משפטי).`,
            ]
        },
        tasks4: {
            title: ` סד"פ אירוע חירום:`,
            tasks: [
                "מתן מענה לאירוע בשגרה ומענה לאירוע בחירום, ביצוע פעילות רשותית בהנחיית הגורמים המקצועיים ברשות ובתיאום עִימם.",
                "הפעלת מכלולים לביצוע הפעולות הנדרשות.",
                "הפעלת המרה\"פ, צוות סע\"ר והחפ\"ק.",
                "ביצוע תיאומים בין גורמי החירום.",
                "מתן עדיפות טיפול באוכלוסיות מיוחדות.",
                "ריכוז והעברת בקשות סיוע של גורמי החירום מהרשות.",
                "הפעלת מפקדות משימתיות בזירת האירוע.",
                "מתן מענה משלים לצח\"י והצח\"ש.",
                "אספקת ציוד ממחסני החירום השונים.",
                "העלאת דרישות לפקע\"ר באמצעות היקל\"ר.",
                "חבירה למפקד מרחבי מטעם פקע\"ר."
            ]
        }
    },

    {
        id: `אוכלוסיה`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        'הגעת מנהל המכלול למטה החירום.',
                        'הפעלת נוהל קריאה למנהלי התאים, מנהלי הצוותים הייעודיים ועובדי המכלולים.',
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        'ביצוע תדריך ראשוני לצוות מנהלי המכלול (תאים וצוותים).',
                        'בדיקת מערכות תקשורת ומידע.',
                        "הגשת בקשה לקבלת מידע ונתוני 'כספת נצורה'.",
                        'הנחיית מנהלי התאים לרענון והדפסת תיקי נתונים.',
                        'רענון סד"פים על פי תרחישים.'
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        'שיח חמ"לים משרדי ממשלה -עדכונים לפי תאים רווחה, בריאות, פנים, דת.',
                        "קבלת סטטוס התייצבות עובדי המכלול.",
                        'צוותים משימתיים - מוכנות מלאה להפעלה לזירת אירוע/ מס"ר.'
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        'ביצוע חיתוך מצב מכלול.',
                        'וידוא ריתוק עובדים חיוניים.',
                        'עדכון עמותות, ספקים, וגורמי מגזר שלישי ומשאבי קהילה רלוונטיים.'
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        'קיום הערכת מצב ראשונה של המכלול.',
                        'השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.',
                        'יצירת קשר ראשוני עם גורמים רלוונטים לתאים.',
                        ' וידוא יכולת עבודה בשתי משמרות ומתן מענה רצוף של המכלול.'
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        'כינוס ועדת פס"ח רשותית לבדיקת מוכנות הרשות לקליטת אוכלוסייה.'
                    ]
                }
            ]
        },

        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                'הקפצת צוות תגובה מיידית אורגני של צוות התערבות רווחה.',
                "הוצאת נתוני אוכלוסייה מפורטים (כולל סטטוס אוכ' עם צרכים מיוחדים) והבאתם לשטח (לשלוח גם בקובץ אם אפשרי). ",
                'קבלת תמונת מצב ראשונית מאוכלוסייה במטה הרובע / שכונה/ צח"י במוא"ז.',
                'שליחת נציג לחפ"ק.',
                'איתור נפגעים במעגלים קרובים לאזור הפגיעה כדי לאתר נפגעי חרדה, יתומים, אנשים עם מוגבלויות וכל צורך אחר בסיוע. ',
                'תהליך מודיעין אוכלוסייה - חבירה לקה"א גדוד פקע"ר בשטח לטובת העברת מידע ונתונים על אוכלוסייה בשטח שנפגע ולמודיעין אוכלוסייה של יחידת הסע"ר (אם קיים).',
                'סיוע בטיפול וליווי משפחות נפגעים באירוע (כולל בבתי החולים).',
                'ליווי ומענה סוציאלי לתושבים חסרי קורת גג (מחסה הולם) ומשפחות נעדרים.',
                'בחינת הצורך במתנדבים (כמות ולאילו משימות) כולל שיח עם ארגוני המתנדבים והעברה אל מכלול כ"א.',
                'הענקת סיוע ראשוני ומתן מידע על אודות הנפגעים עפ"י נהלים וצוותים שהוגדרו מראש. ',
                'איתור ואבחון קבוצות אוכלוסייה הנזקקות לסיוע לאור המצב ומתן מענה (כולל אוכלוסיות מיוחדות המוכרות לרשות טרם האירוע- מהאזור הנפגע ומכלל הרשות).',
                'במידת הצורך – הגדרת מיקום לפינוי חללים ותיאום פעילות מול תר"ח.',
                "אם נדרש – היערכות להפעלת צוות 'הודעה מרה'.",
            ]
        },

        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                'ריכוז תמונת מצב אוכלוסייה למרכז סיוע ראשוני.',
                'הפעלת צוותי רווחה כמענה לתושבים: נפגעים, נעדרים, משפחות חלל.',
                'העברת נתוני האוכלוסייה לרובע/שכונה/ יישוב.',
                "הפעלת צוות 'בשורה מרה' על פי צורך.",
                'איתור אנשים ממסגרות הדיור, מענה ליתומים ונעדרי תמיכה משפחתית.',
            ]
        },

        tasks4: {
            title: `סד"פ שגרת חירום`,
            tasks: [
                {
                    subTitle: "תא רווחה",
                    subTasks: [
                        "ביצוע תיאומים מקצועיים בין הרשות לבין גורמי ביצוע ממשלתיים מקצועיים.",
                        "תיאומים עם ארגוני מתנדבים ומערכים קהילתיים, היערכות להפעלת צוות משפחות והתערבות.",
                        "מתן סעד חברתי ונפשי לאוכלוסייה."
                    ]
                },
                {
                    subTitle: "תא בריאות",
                    subTasks: [
                        "אספקת מידע למוקד הרשותי בנושא שירותי בריאות בחירום.",
                        "אספקת שירותי בריאות שבאחריות הרשות."
                    ]
                },
                {
                    subTitle: "תא פס\"ח",
                    subTasks: [
                        "וידוא מוכנות הרשות ומתקני הקליטה לקליטת אוכלוסייה מפונה מהרשות ותושבי רשויות אחרות, בתיאום עם הגורם המפנה.",
                        "תיאום מכלולי הרשות לטיפול שוטף באוכלוסיית המפונים לרבות שירותי לינה, כלכלה, רווחה, חינוך ובריאות.",
                        "הפעלת התר\".ח הרשותי, ריכוז נתונים ודיווח על חללים והשהיית החללים לצורך זיהוי"
                    ]
                },
                {
                    subTitle: "תא עלייה וקליטה",
                    subTasks: [
                        "ביצוע תיאומים מול משרד העלייה והקליטה.",
                        "היערכות למתן מענה לצרכים הייחודים של אוכלוסיית העולים כתוצאה מהמצב במתקנים ובקהילה."
                    ]
                },
                {
                    subTitle: "תא דת",
                    subTasks: [
                        "מתן שירותי דת חיוניים לאוכלוסייה כבשגרה.",
                        "תיאום בין הגופים העוסקים בשירותי דת בתחומי הרשות."
                    ]
                },

                " קיום דיוני חשיבה לתכנון שבועי לטיפול באוכלוסייה. ",
                "תחקור אירועים מרכזיים והפקת לקחים.",
                "גיבוש תמונת מצב מתמשכת של האוכלוסייה."
            ]
        },
    },


    {
        id: `חינוך`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הפעלת נוהל קריאה למנהל המכלול למטה החירום הרשותי.`,
                        `הפעלת נוהל קריאה למנהלי התאים, בעלי התפקידים במכלול ומפקחת מתכללת רשותית.`,
                        `חבירה טלפונית לקב"ט מחוזי משרד החינוך וקבלת הנחיות חדר מצב.`,
                        `העברת הנחיות ראשונות למנהלי מוסדות החינוך ולמסגרות החינוך הבלתי פורמלי והיערכות לפתיחת מקלטים במבני מוסדות החינוך.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `ריכוז תמונת מצב.`,
                        `תחילת התארגנות למעבר לעבודת המכלול במרכז ההפעלה הרשותי, בדיקת כשירות אמצעי התקשוב.`,
                        `עדכון רשימת בעלי התפקידים וצבירת הגעת כוח-אדם למכלול.`,
                        `בדיקת המצאות תיקי חירום, נתוני מערכת החינוך ועזרי מטה במכלול, לרבות טבלאות שליטה, דרכי תקשורת ועוד.`,
                        `השתתפות מנהל המכלול בחיתוך מצב רשותי (ניתן להיעזר בדגשים להתייחסות במנחה המקצועי - נספח 4).`,
                        `פרסום הנחיות ומידע להורים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `סטטוס התייצבות מנהל מכלול החינוך, מס' 2, מנהלי התאים ובעלי תפקידים חיוניים.`,
                        `גיבוש סטטוס מוסדות חינוך (זמינות בעלי תפקידים הוראה ומנהלה), כולל מסגרות הגיל הרך.`,
                        `תדריך לצוות המכלול  בהתאם להנחיות והחלטות שהתקבלו בחיתוך מצב רשותי וחדר מצב מחוזי.`,
                        `במועצות אזוריות - תדריך לממונה חירום בצח"י.ברשויות גדולות - תדריך מ_matrices רובעים/ חבלים.`,
                        `וידוא פתיחת מקלטים ציבוריים במוסדות חינוך (במידה וניתנה הנחייה).`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלול.`,
                        `הגעת מפקח/ת מתכלל/ת רשותית למכלול החינוך במרה"פ.`,
                        `היערכות להפעלת מפ"ל (מסגרת פעילות לילדי עובדים חיוניים של הרשות) במידת הצורך.`,
                        `ריענון למנהלי מוס"ח בנוהל פיזור תלמידים (נוהל משרד החינוך דצמבר 2023).`,
                        `בדיקת סטטוס מוסדות חינוך המיועדים לשמש מתקני קליטת אוכלוסייה.`,
                        `היערכות להפעלת מתנדבים בני נוער במידת הצורך ובהתאם להנחיות ההתגוננות.`,
                        `היערכות להפעלת תכנית "זמן יקר".`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `קבלת תמונת מצב עדכנית ממנהלי התאים, שפ"ח, קב"ט מוס"ח, מפקח מתכלל רשותי.`,
                        `עדכון נתוני התלמידים בכלל המסגרות הפורמלי והבלתי פורמלי, נתוני ילדי חינוך מיוחד וצרכים מיוחדים.`,
                        `ביצוע הערכת מצב מכלולית`,
                        `השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.`,
                        `היערכות לתגבור מוקד המידע הרשותי באנשי חינוך ושפ"ח.`,
                        `בדיקה וריענון של "הודעות נצורות" לצוותי הוראה ולהורים ופרסום הנחיות ומידע חיוני על-פי הצורך.`,
                        `במידה ומתקיימים לימודים חלקי/מלא - הנחייה למנהלי מוס"ח לביצוע תרגולים וריענונים: כניסה למרחבים מוגנים, צל"ח, סע"ר, מתקני קליטה.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `הפעלת מתנדבים בני נוער במידת ההצורך ובהתאם להנחיות מדיניות ההתגוננות.`,
                        `היערכות ללמידה מרחוק (בכפוף להנחיות חדר מצב מחוזי).`,
                        `מעבר לעבודה בשתי משמרות.`,
                        `עבודה עפ"י שעון פעילות.`,
                        `הפעלת מסגרות חינוכיות (פורמלי ובלתי פורמלי) בהתאם למדיניות ההתגוננות.`,
                    ]
                },                {
                    subTitle: ` תא חינוך פורמלי:`,
                    subTasks: [
                        "הפעלת נוהל קריאה לבעלי התפקידים בתא.",
                        "קבלת הנחיות מנהֵל מכלול החינוך וביצוע התיאומים המקצועיים הנדרשים בין הרשות לבין מטה מחוז משרד החינוך לגבי הפעלת מערכת החינוך הפורמלית ברמות השונות.",
                        "היערכות להפצת מידע להורים על אודות הפעלת מערכת החינוך (באמצעות מכלול מידע לציבור)."
                    ]
                },
                {
                    subTitle: ` תא חינוך בלתי פורמלי:`,
                    subTasks: [
                        "הפעלת נוהל קריאה לבעלי התפקידים בתא.",
                        "ביצוע תיאום בין הנחיות מטה החירום הרשותי לבין מנהל חברה ונוער מחוזי.",
                        "היערכות להפצת מידע להורים על אודות הפעלת מערך החינוך הבלתי פורמלי (באמצעות מכלול מידע לציבור).",
                        "וידוא פוטנציאל מתנדבים בני נוער לסיוע במשימות הרשות."
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `הוצאת דיווח ראשוני למנהלי התאים ובעלי התפקידים במכלול. הנחיה לנציג מכלול החינוך להיערך לצאת לזירת הנפילה עם החפ"ק הרשותי (ווסט זיהוי). חבירת נציג השפ"ח למכלול אוכלוסייה.`,
                `גיבוש תמונת מצב מנתוני מיקום נפילת הטיל: מוסדות חינוך בפוליגון (פעילים/לא פעילים/פעילים חלקית)  באיזו מתכונת, כולל נתוני מיגון (ע"פ מדרג המדיניות), נתוני מפ"ל ומעונות יום לילדי עובדים חיוניים.`,
                `גיבוש תמונת מצב תלמידים ועובדי הוראה בזירת ההרס - ע"ב מידע שמתקבל בחפ"ק הרשותי, ביקל"ר ובמכלול האוכלוסייה והצלבה עם מידע שמתקבל ממנהלי מוסדות החינוך. `,
                `אם יש נפגעים, נעדרים, או לכודים – יש להנחות על קבוצת מיפוי מעגלי פגיעה, בתיאום מול מכלול האוכלוסייה ובשיתוף שפ"ח ומנהלי מוסדות החינוך.`,
                `ביצוע חיתוך מצב ראשוני במכלול לעדכון רוחבי של מה שידוע עד כה ומתן הנחיות להמשך.`,
                `הוצאת הודעת עדכון והנחיות למנהלי מוסדות החינוך (מומלץ הודעה קולית או סרטון וידיאו של מנהל מכלול החינוך).`,
                `הנחיה להיערך לתמיכה והתערבות ראשונית: - פתיחת "קו חם" בחינוך - הפצת מסמך "כלים להתמודדות" להורים וצוותי החינוך.`,
                `סיוע למכלול האוכלוסייה בטיפול במשפחות שנפגעו ובמשפחות שנדרשו להתפנות מבתיהן (מרכז סיוע ראשוני, מרכז חוסן). `,
                `היערכות לסיוע בקליטת משפחות עם ילדים בבתי מלון וביצוע פעילות בלתי פורמלית לילדים במהלך השהייה במלונות.`,
                `בחינת הצורך במתנדבים (כמות ולאילו משימות) והעברה אל מכלול כ"א.`,
                `ביצוע תחקיר ראשוני והפקת לקחים בסמוך ככל האפשר לסיום האירוע.`,

            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `סיוע בפתיחת מרכז סיוע ראשוני.`,
                `חיבור לצוות המתקן.`,
                `תדרוך הצוותים והפעלתם ברובעים/שכונות/יישובים.`,
                `הפעלת פעילות הפגה בסיוע כ"א ומתנדבים.`
            ]
        },
        tasks4: {
            title: ` סד"פ שגרת חירום`,
            tasks: [
                "מנהל מכלול החינוך יאסוף מידע מהשטח, ממכלולים מקבילים, מהיקל\"ר וממשרד החינוך וימליץ על אופן הטיפול באירועים בתחום החינוך הפורמלי והבלתי פורמלי.",
                "יאסוף מידע וינתח את צרכי מערך החינוך והתלמידים באזור האירוע וימליץ על אופן הטיפול וכן יאסוף מידע ממקורות רשותיים הנמצאים באזור האירוע.",
                "ינחה על שליחת צוותים מקצועיים (שפ\"י/שפ\"ח), צוותי חינוך והדרכה לאזורים שנפגעו ולאוכלוסיות מועדפות.",
                "יהיה שותף בצוות התערבות רב-מקצועי טיפולי מתוגבר באנשי השירות הפסיכולוגי.",
                "מנהל המכלול ינחה על הפחתת פעילות בלתי פורמלית במתקנים וינחה להכינם לפעילויות רשותיות בחירום.",
                "ינחה להפעיל מערכת חינוך חלופית בהתאם לצורך."
            ]
        },
    },

    {
        id: `מידע לציבור`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הפצת הודעות מצילות חיים לתושבים בכל הפלטפורמות.`,
                        `הפעלת נוהל קריאה למנהל המכלול למטה החירום הרשותי.`,
                        `הודעות להורים במוסדות החינוך.`,
                        `העלאת פתיח למוקד.`,
                        `הפעלת נוהל קריאה למנהלי התאים ועובדי מכלול מידע לציבור.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `הכוונת תושבים ללא מיגון בהתאם למדיניות ולעיתוי.`,
                        `המשך הפצת הנחיות מצילות חיים.`,
                        `מעבר לכל הפלטפורמות במתכונת חירום.`,
                        `יצירת קשר עם פיקוד העורף: קבלת מדיניות התגוננות, בדיקת נוהל 104/106, ווידוא כניסה למנג"ל. קבלת קובץ שאלות ותשובות.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `התייצבות כוח אדם לתגבור המוקד.`,
                        `תיאום אל מול מובילי דעת קהל.`,
                        `הפצת הנחיות התגוננות וחיזוקן והפצת מדיניות התגוננות.`,
                        `הפצת מידע על שירותים חיוניים.`,
                        `הפצת מידע על מרחבים מוגנים הפתוחים לקבל.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלול.`,
                        `גמר תגבור המוקד כולל מענה לשפות.`,
                        `ניטור שיח רשותי.`,
                        `פתיחת קו תמיכה נפשית.`,
                        `מוכנות כ"א לפתיחת לשכות מידע.`,
                        `הפעלת "זמן יקר", ביצוע הדרכות וריענונים לצוות המכלול.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `ביצוע הערכת מצב מכלולית.`,
                        `השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.`,
                        `מוכנות לפתיחת גנרציה במוקד העירוני לפלטפורמות הדיגיטל.`,
                        `הפצת תוכניות הסברה נצורות בהתאם לתרחיש ולצורך- בפרט לקהלי יעד שעלו בניתוח פערי המידע.`,
                        `במידה ולא הופץ עד כה: הפצת סרטון לראש הרשות : מסר מרכזי: מוכנות העירייה על כלל אגפיה, שמירה על הנחיות ההתגוננות, הזמנת תושבים לפנות לעירייה במידת הצורך, הפניה למקורות המידע שהעירייה מפיצה בפלטפורמות השונות.`,
                        `מוכנות מלאה לפריסה של לשכות מידע בהיבטי כ"א ללשכה וציוד.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `יצירת קשר וידוא מסוגלות הפעלה של מכרזים נצורים בבתי דפוס.`,
                        `מעבר לעבודה במשמרות -  פתיחת עמדות מורחבת ותגבור עובדי המוקד.`,
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `עם קבלת עדכון רשמי על אירוע ממכלול המבצעים, פרסום מיידי של הודעה לציבור על האירוע והנחיות להתנהלות האוכלוסייה בכל אמצעי המדיה והתקשורת.`,
                `תגבור מוקדנים במוקד הרשותי לצורך מתן מענה לפניות התושבים במידע השוטף גם בכל הקשור לשירותים המוניציפליים.`,
                `איסוף נתונים על מוקד הנפילה (דיווחים במוקד, מצלמות וכד') והעברה למכלול מבצעים.`,
                `הוצאת הודעה רשמית מטעם ראש הרשות לתושבים בהתאם להתפתחות האירועים.`,
                `מתן מידע לציבור ליתר תושבי הרשות (שלא באזור האירוע) ע"י הפלטפורמות השונות ותיאום המסרים עם כוחות החירום הרלוונטיים (כולל- הימנעות מהתקהלות ומהגעה לזירה, מיקומי לשכות מידע לציבור ומידע בנוגע למס רכוש).`,
                `הקמת לשכת מידע לציבור בהתאם לצורך. `,
                `ריכוז מידע על נפגעים ומפונים כדי שיהווה בסיס מידע לפניות הציבור, או פרסום מידע בעניין, ע"פ הצורך. `,
                `צפייה והאזנה לפרסומים בתקשורת באופן רצוף, במטרה להכיר ולדעת את המידע המפורסם שיכול להוות בסיס לפניות רבות של הציבור.`,
                `חבירה לנציג מידע לציבור ברובע (צח"י - במוא"ז) לטובת תיאום מסרי ההסברה.`,
                `יצירת תמ"ץ פניות תושבים למוקד (פילוח נושאי השיחה) + ברשתות החברתיות + במוקד 104 + עיבוד המלצות לדרג הבכיר.`,
                `הפעלת מערך הסברה ייעודי לאוכלוסיות בעלות מאפיינים ייחודיים (מבוגרים, חצר"מים, בעלי מוגבלויות וכד').`,
                `גיבוש תוכנית הסברה רשותית מתאימה למצב ברשות.`,
                `הגדרת בעל תפקיד לליווי אמצעי תקשורת מטעם הרשות.`,

            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `פתיחת עמדת מידע לציבור ושילוט חוץ להכוונה ושילוט פנים למקום.`,
                `טופס רישום פניה ומעקב אחר הטיפול, ניהול יומן אירועים ידני.`,
                `העברת מידע בין הרשות לתושבים - קבלת הנחיות והפצתן, איסוף, ניתוח נתונים ופערים והעברתם לידיעה ולמענה הרשות. קבלת דרישות ופניות מהתושבים והעברתן לטיפול במכלולים הרלוונטיים.`,
                `מתן מידע אודות סדרי החיים - חלוקת חומרי מידע והנחיות מודפסים ומענה פרונטלי "פנים אל פנים".`,
                `עדכון מתמשך מאת נציג הרשות עבור התושבים לרבות זכויות והמשך טיפול מס רכוש.`,
            ]
        },
        tasks4: {
            title: `סד"פ בחירום:`,
            tasks: [
                "ריכוז מידע, גיבוש תמונת מצב, הערכת מצב וגיבוש המלצות מקצועיות לשולחן המרכזי.",
                "ייעוץ לראש הרשות ומתן פתרונות בתחום ההסברה, הדוברות והנגשת המידע.",
                "ניתוח מדיניות התגוננות והפצת המשמעויות הנגזרות ממנה לתושבי הרשות, לרבות מתן מידע ומענה על אופן ניהול שגרת החירום והשירותים החיוניים - חינוך, מקומות עבודה, תחבורה ציבורית, רווחה, בריאות ועוד.",
                "הפצת מסרים והנחיות של פיקוד העורף בפלטפורמות הרשותיות וביצוע פעולות הסברה יזומות ומותאמות לתושבי הרשות ולקהלי היעד המגוונים ברשות, לרבות הפצת תוצרי מערכת VOD כתום (כולל המנג\"ל) ברשתות החברתיות, סיקור פעולות הרשות לתמיכה בתושבים, העברת מסרים מראש הרשות וגיוס מובילי דעת קהל להפצת המסרים.",
                "חיזוק האמון באמצעות הפצת מידע באופן שוטף וקבוע."
            ]
        },
        tasks4: {
            title: ` סד"פ אירוע חירום:`,
            tasks: [
                "העברת מידע והנחיות מצילות חיים לתושבים באופן מיידי, אמין ורלוונטי, מותאם להנחיות גופי החירום.",
                "תגבור מוקד המידע הטלפוני בהתאם לאירוע ועל פי צורך.",
                "מתן מענה לתגובות, שאלות ושמועות / מידע כזב ברשתות החברתיות, לצד היערכות לעלייה משמעותית בפניות ולצורך של התושבים במידע ובמסרים בזמן שבו מתגבשת הערכת המצב.",
                "איסוף מידע מהתושבים והשטח באמצעות המוקד ומעקב אחר הפרסומים באמצעי התקשורת וברשתות החברתיות.",
                "קבלת מידע, ארגונו והפצתו בשיתוף גורמים מוסמכים פנימיים (שולחן מטה, מכלולים, צוותי צח\"י במועצות אזוריות) וחיצוניים (פיקוד העורף, משטרה, מד\"א וכב\"ה).",
                "היערכות לפתיחת לשכת מידע מקומית באזור האירוע."
            ]
        }
    },

    {
        id: `הנדסה ותשתיות`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הפעלת נוהל קריאה למנהל המכלול למטה החירום הרשותי.`,
                        `הפעלת נוהל קריאה למנהלי התאים ועובדי מכלול הנדסה ותשתיות.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `בדיקת כשירות האמצעים ותקינות התקשורת במכלול ובתאים.`,
                        `תחילת התארגנות למעבר עבודה במכלול במרכז ההפעלה.`,
                        `יצירת תמונת מצב של עבודות הבינוי והתשתיות המבוצעות בתחומי הרשות, לרבות קשר עם הקבלנים והספקים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `יצירת קשר עם הקבלנים והספקים המופעלים בחוזים לשעת חירום.`,
                        `בחינת דרכי הקשר עם משרדי הממשלה וגופי החירום.`,
                        `קבלת סטטוס התייצבות עובדי המכלול.`,
                        `ביצוע הדרכות רענון לצוות המכלול ולמתנדבים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלול.`,
                        `וידוא גיוס צוותי הנדסה ותשתיות ומוכנותם למילוי תפקידם (כוח אדם, ציוד, רכב ומשאבים).`,
                        `תיקוף תוכנית המענה של התאים.`,
                        `וידוא ריתוק עובדים חיוניים.`,
                        `הערכות להפעלת 'זמן יקר' ומעבר על הנהלים (היערכות בשגרה ותפקידים בחירום).`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `ביצוע הערכת מצב מכלולית.`,
                        `השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.`,
                        `וידוא יכולת עבודה בשתי משמרות לפחות ("שעון פעילות).`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `העלאת דרישה למהנדסי מיון מבנים ממשרד השיכון והבינוי.`,
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `הפעלת צוותי תשתיות וחבירתם לחפ"ק האחוד. `,
                `וידוא ניתוק תשתיות מסכנות חיים באתר ההרס בהנחיית מפקד הזירה: משטרת ישראל/ פקע"ר/ כב"ה/ ספק חברת גז וחשמל. `,
                `הכנת עזר גרפי והעברת המלצות לגבי מיקום חסימות בשטח, מיקום החפ"ק ונקודת כינוס כלי הצמ"ה.`,
                `מתן מענה למחסור בתשתיות שנפגעו עד לתיקונן ע"י הגופים הרלוונטיים, לרבות תשתיות מים, חשמל וכבישים.`,
                `הפעלת מערכת GIS הרשותית לטובת מידע רלוונטי למכלולי הרשות.`,
                `הוצאת תוכניות הנדסיות למבנים שנפגעו לכוחות החילוץ (שליחת קובץ דיגיטלי וכן גרמושקה מודפסת לשטח) והעברתם לחפ"ק.`,
                `הוצאת מהנדסים למקום האירוע לטובת מיון מבנים. `,
                `מס רכוש – מינוי איש קשר רשותי לטיפול בנושא מול האוכלוסייה שנפגעה ולשיקום פיזי של המבנים שנפגעו.`,
                `מתן מענה למחסור בתשתיות שנפגעו עד לתיקונן ע"י הגופים הרלוונטיים לרבות תשתיות מים וחשמל.`,
                `הפעלת מערך GIS הרשותי לטובת מידע רלוונטי למכלולי הרשות (מיפוי גרפי).`,
            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `אפיון וסיווג מבנים בנקודות הפגיעה והעברת המידע לנציג לצוות המכלול במרכז הסיוע.`,
                `מתן מידע לתושב על פי סיווג דירתו.`,
                `חבירה למס רכוש והפעלת עמדת מס רכוש כמענה לתושבים.`,
                `תגבור על פי צורך של עמדת הנדסה- מס רכוש בכ"א נוסף.`,
            ]
        },
        tasks4: {
            title: `סד"פ שגרת חירום`,
            tasks: [
                "מטה המכלול ערוך במקומו.",
                "צוותי הנדסה ותשתיות מוכנים למתן מענה.",
                "השתתפות בקבוצות תכנון."
            ]
        },
        tasks4: {
            title: ` סד"פ אירוע חירום:`,
            tasks: [
                "הפעלת מנהלי התאים לביצוע הפעולות הנדרשות.",
                "הפעלת צוותי הנדסה ותשתיות.",
                "סיווג מבנים לאחר פגיעה לטובת אישור או שלילת אכלוס.",
                "ביצוע תיאומים בין גורמי חירום ומס רכוש.",
                "מתן עדיפות לטיפול בתשתיות חיוניות ומפעלים חיוניים.",
                "בקשת סיוע - אם נדרש."
            ]
        }
    },

    {
        id: `לוגיסטיקה ותפעול`,

        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הגעת מנהל המכלול למטה החירום.`,
                        `הפעלת נוהל קריאה למנהלי התאים ועובדי המכלולים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `בדיקת כשירות ומצאי האמצעים במחסני הרשות ואצל כל הספקים.`,
                        `קבלת תמונת מצב אמצעי ניוד חברות ההיסעים, התובלה והצמ"ה.`,
                        `ניהול עזרים, איתור ועידוד פערי ציוד ודלק.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `שיח חמ"לים משרדי ממשלה -עדכונים לפי תאים , מזון ומשכ"ל, גיבוי אנרגטי, תברואה, רכש ואספקה ותחבורה.`,
                        `  היערכות מול חברות ההיסעים לתוכנית היסעים לתלמידים בחירום, הסעות עובדים או מפונים במידת הצורך.`,
                        `ווידוא הערכת כלל התאים לביצוע משימותיהם.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלול.`,
                        `הפעלת "זמן יקר", ביצוע הדרכות וריענונים לצוות המכלול.`,
                        `וידוא ריתוק עובדים חיוניים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `ביצוע הערכת מצב מכלולית.`,
                        `השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.`,
                        `וידוא יכולת עבודה בשתי משמרות לפחות ("שעון פעילות).`,
                        `יבצע בדיקת גנרטורים ויוודא תקינות ומלאי חלקי חילוף.`,
                        `לוודא תיאום המשך הפעלת קווי תחב"ץ למפעלים חיוניים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `יצירת תמונת מצב ע"י קשר עם סניפי רשתות השיווק והמרכולים וחברות ההסעדה, וקבלת נתונים לגבי פתיחת הסניפים, התייצבות כוח-אדם, מלאי מוצרים, יכולות גנרציה וכ"א ויעדכן את ממוני מזון משכ"ל מחוזי במשרד הכלכלה.`,
                        `וידוא ביצוע פעולות איסוף אשפה יסודיות והצבת מכולות אשפה בסמוך למקלטים ציבוריים.`,
                        `יצירת קשר עם תחנות "צי הברזל" בתחום הרשות ובסביבתה הקרובה להבנת תמונת המצב ויכולת אספקת דלק.`,
                        `השתתפות נציג מהמכלול בוועדת משנה לפס"ח.`
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `חבירה למכלול מבצעים להבנת האירוע והצרכים הלוגיסטיים.`,
                `שליחת נציג לחפ״ק בשטח האירוע והבנת הצרכים הנדרשים ליחידות הפועלות בשטח (צוותי התערבות רשותיים, יחידת חילוץ רשותית, גופים חבירים) ועבור הקמת הפעלת מס"ר.`,
                `אספקה מיידית של ציוד בידוד זירה (סרטי סימון, מחסומים).`,
                `ארגון מיידי של המס״ר לאחר ההכרזה על מיקומו: ריהוט, מזון, שתיה, שילוט, גנרציה – על פי רשימת ציוד.`,
                `השלמת ציוד לוגיסטי לזירה: מזון, מים, ערכות תאורה, תמוכות, דלקים, שמנים, ציוד חילוץ, שירותים ניידים וכל הנדרש על ידי החפ״ק.`,
                `הובלות: סיוע ברכבי הסעה והובלה למס״ר ולמשימות החפ״ק.`,
                `פינוי פסולת בניין מהזירה באמצעות צמ״ה וקבלנים.`,
                `פינוי רכבים מהזירה לאחר שמאות, בתיאום עם מס רכוש.`,
                `אמצעים נוספים: גנרציה וסולר לצורכי החפ״ק, יחידת החילוץ הרשותית  ולמס״ר על פי צורך.`,
                `היערכות לשהייה ארוכה, כולל פניה לרשויות סמוכות לסיוע במידת הצורך.`,
            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `שינוע עגלת הקליטה למקום (שילוט והכוונה, מחשבים וכדומה).`,
                `הכנת המרכז לפתיחה.`,
                `הפעלה שוטפת לרבות: מים, כיבוד קל, ניקוי.`,
                `סיוע בפינוי אוכלוסייה לאתרים שתואמו על ידי הרשות.`,
                `סיוע במידת הצורך בתיאום אתרים לפינוי (מלונות).`,
            ]
        },
        tasks4: {
            title: ` סד"פ שגרת חירום:`,
            tasks: [
                "החלטה לגבי מעבר לעבודה במשמרות.",
                "ביצוע הע \"מ מכלולית ע\"פ שעון לחימה.",
                "המשך ביצוע הדרכות וריענונים לצוות המכלול ככל שהזמן מאפשר - בחינת היכולת והצורך בהפעלת \"זמן יקר\".",
                "המשך בדיקת כשירות האמצעים ומצאי במחסני הרשות ואצל כל הספקים.",
                "השתתפות ב\"תמונת מצב\" או \"הערכת מצב\" בראשות ראש הרשות.",
                "העברת עדכון יומי למכלול מידע לציבור בנושאי: מזון, משכ\"ל, תחב\"ץ, תברואה.",
                "השתתפות נציג מהמכלול בוועדת משנה לפס\"ח.",
                "השתתפות נציג מהמכלול בקבוצת קליטה.",
                "השתתפות נציג בכיר מהמכלול בכל קב' תכנון, הע \"מ או תמ\"ץ רשותית.",
                "ניהול עזרים, איתור ועיתוד פערי ציוד ודלק.",
                "לוודא קשר רצוף עם כל רשויות החירום הרלוונטיות בכל התאים.",
                "שיח עם כלל מנהלי המכלולים כדי לוודא פערים, צרכים שוטפים ונוהלי עבודה משותפים.",
                "יושם דגש מיוחד על וידוא הכנות בתחום הגיבוי האנרגטי עם מנהל תא גיבוי אנרגטי.",
                {
                    subTitle: `תא תחבורה`,
                    subTasks: [
                        "שימור תמונת מצב באמצעות קשר עם חברות ההיסעים, התובלה והצמ\"ה.",
                        "יפעיל תוכנית היסעים לתלמידים בחירום, הסעות עובדים או מפונים במידת הצורך (פינוי מבצעי באחריות הגורם המנהל את האירוע).",
                        "יקצה כלי רכב, הובלה וצמ\"ה לפעילות מטה החירום של הרשות.",
                        "יוודא ויתאם המשך הפעלת קוי תחב\"ץ למפעלים חיוניים.",
                        "יעדכן את מכלול המידע לציבור בכל הקשור בתחבורה.",
                        "יגבש תמונת מצב בתחום התחבורה ויעמוד בקשר עם הרשות העליונה לתחבורה."
                    ]
                },
                {
                    subTitle: `תא מזון ומשכ"ל`,
                    subTasks: [
                        "יקיים תמונת מצב רצופה עם סניפי רשתות השיווק והמרכולים ויקבל נתונים לגבי פתיחת הסניפים, התייצבות כ\"א, מלאי מוצרים ויעדכן בכך את ממוני מזון משכ\"ל מחוזי במשרד הכלכלה בטופס המקוון שיישלח אליו.",
                        "יקיים תמונת מצב רצופה מול חברות ההסעדה ויספק מזון לכלל מתקני הרשות (משימה רשותית פנימית שלא באחריות משרד הכלכלה וטיפולו).",
                        "יעדכן את מכלול המידע לציבור בנוגע לסניפים סגורים, שינוי שעות פתיחת הסניפים, פערי מלאי וכו'.",
                        "יצור קשר עם המפעלים החיוניים בתחום המזון והמשכ\"ל, לסיוע רשותי במקרה הצורך (תברואה, סדר ציבורי, תחבורה ציבורית).",
                        "יגבש תמונת מצב בתחום המזון והמשכ\"ל ויעמוד בקשר עם ממוני מזון משכ\"ל מחוזי במשרד הכלכלה."
                    ]
                },
                {
                    subTitle: `תא תברואה`,
                    subTasks: [
                        "יעמוד בקשר עם חברות פינוי האשפה והגזם.",
                        "פינוי פסולת לסוגיה ככל שיידרש במצב חירום, בהתאם להנחיות מקצועיות של המשרד להגנת הסביבה ובתיאום עם המחוז במשרד להגנת הסביבה ומשרד הפנים.",
                        "ינחה על ביצוע פעולות איסוף אשפה יסודיות ככל הניתן ע\"פ רמות השירות שהוגדרו ע\"י מנהל המכלול.",
                        "יעדכן את מכלול המידע לציבור.",
                        "יגבש תמונת מצב בתחום התברואה.",
                        "יעמוד בקשר עם הרשות העליונה במשרד להגנת הסביבה."
                    ]
                },
                {
                    subTitle: `תא רכש ואספקה`,
                    subTasks: [
                        "עומד בקשר עם הספקים השונים ואחראי למחסני הרשות בשגרה.",
                        "יבצע רכש מואץ ע\"פ דרישות המכלולים.",
                        "יעדכן מסגרות תקציב ממקורות שונים.",
                        "יעמוד בקשר עם חברות הביטוח והשמאים.",
                        "יקצה ציוד בכפוף להנחיות הרשות וידאג להשלמת סיוע וקליטתו אם יידרש."
                    ]
                },
                {
                    subTitle: `תא גיבוי אנרגטי`,
                    subTasks: [
                        "יוודא מלאי דלק מרבי בכל זמן.",
                        "יבצע בדיקת גנרטורים ויוודא תקינות ומלאי חלקי חילוף.",
                        "יבצע בדיקה מול צרכני הדלק והגפ\"ם של הרשות – לתיאום ציפיות.",
                        "יקיים קשר עם כלל המפעלים החיוניים, בדגש על מרכולים, להבנת תמונת מצב ואורך נשימה אנרגטי בכל אחד מהם.",
                        "יקיים קשר עם תחנות \"צי הברזל\" בתחום הרשות ובסביבתה הקרובה, להבנת תמונת המצב ויכולת אספקת דלק.",
                        "יעדכן את מכלול המידע לציבור.",
                        "במקרה של פערים יעלה צרכים מול הרמה המחוזית."
                    ]
                },
            ]
        },
    },

    {
        id: `מינהל כללי ומשא"ן`,
        tasks1: {
            title: `סד"פ מעמ"ל`,
            tasks: [
                {
                    subTitle: `הפעלה + 15 דק'`,
                    subTasks: [
                        `הגעת מנהל המכלול למטה החירום.`,
                        `הפעלת נוהל קריאה למנהלי התאים ועובדי המכלולים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 30 דק'`,
                    subTasks: [
                        `בדיקת כשירות אמצעי המכלול ותשתיות ותיקונם.`,
                        `בדיקת תקינות אמצעי התקשורת במרכז ההפעלה ומתן תמיכה טכנית.`,
                        `וידוא עמדת GSI ואינטרנט במטה החירום.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעה'`,
                    subTasks: [
                        `תיקוף תוכנית המענה של המכלול.`,
                        `עדכון תיק תכנון כוח אדם במידת הצורך.`,
                        `בדיקת סטטוס התייצבות עובדים בחתך מכלולים ותפקידים.`,
                        `מיפוי פערים של בעלי תפקידים קריטיים ומידת השפעתם על רציפות התפקוד של המכלול והרשות.`,
                        `הפצת רשימת המפעלים החיוניים בשטח הרשות למכלולים.`,
                    ]
                },
                {
                    subTitle: `הפעלה + שעתיים'`,
                    subTasks: [
                        `ביצוע חיתוך מצב מכלול.`,
                        `העברת מידע למכלול מידע לציבור לטובת אספקה לתיירים באמצעות לשכות המידע לתיירים.`,
                        `פריסת מערכות מידע במטות ההפעלה (רובע) ובלשכות המידע.`,
                        `הפעלת "זמן יקר", ביצוע הדרכות וריענונים לצוות המכלול.`,
                        `תגבור כוח אדם, יצירת קשר וקבלת תמונת מצב ראשונית ממפעלים חיוניים התומכים ברשות המקומית בכוח אדם.`,
                    ]
                },
                {
                    subTitle: `הפעלה + 6 שעות'`,
                    subTasks: [
                        `ביצוע הערכת מצב מכלולית.`,
                        `השתתפות מנהל המכלול בהעמ"צ בראשות ראש הרשות.`,
                        `וידוא יכולת עבודה בשתי משמרות לפחות ("שעון פעילות).`,
                    ]
                },
                {
                    subTitle: `הפעלה + 12 שעות'`,
                    subTasks: [
                        `סיוע בפינוי תיירים והחזרתם לארצם.`,
                    ]
                }
            ]
        },
        tasks2: {
            title: `סד"פ אירוע הרס`,
            tasks: [
                `הוצאת צווי גיוס לעובדי הרשות שבריתוק משקי.`,
                `ניהול שבצ"ק של כל מכלולי הרשות והמתנדבים המשויכים למכלולים (בעיקר מי שיצא לאתרי הרס).`,
                `קבלת עדכון על הצורך במתנדבים מכלל המכלולים, העברתו למנכ"ל וקביעת סד"ע.`,
                `הקצאת כ"א למתקני הרשות שייפתחו לרבות מתקן הקליטה, מרכז סיוע ראשוני, לשכות מידע. `,
                `ניהול מאגר נתונים וביצוע קליטה מנהלתית של המתנדבים ותכנון משימות עבור עובדי הרשות בתיאום עם המכלולים השונים ותיעדוף משימות.`,
                `טיפול בתיירים ובעובדים זרים בהתאם למדיניות הממשלה.`,
                `טיפול בעובדי רשות שנפצעו/ משפחות שנפצעו (במידת הצורך).`,
                `פתיחת חמ"ל מתנדבים, הפעלת צוות שטח לניתוב מתנדבים אקראיים לחמ"ל המתנדבים.`,

            ]
        },
        tasks3: {
            title: `סד"פ מס"ר - מרכז סיוע ראשוני (מרכז משפחות)`,
            tasks: [
                `הפעלת כוח אדם הנדרש למשימה – כ"א של מרכזי הקליטה.`,
                `קליטת המתנדבים והפעלתם – פעילויות הפגה.`,
                `סיוע בגיוס אמצעים (ביגוד וכו') אל מול ארגוני מתנדבים.`,
            ]
        },
        
        tasks4: {
            title: ` סד"פ אירוע חירום:`,
            tasks: [
                "הפעלת מנהלי התאים לביצוע הפעולות הנדרשות.",
                "הפעלת עובדים.",
                "ביצוע תיאומים בין גורמי חירום.",
                "מתן עדיפות בטיפול בתשתיות חיוניות ובמפעלים.",
                "בקשת סיוע, אם נדרש.",
                "וידוא כי כלל מנהלי התאים פועלים לפי תפקידם ומשימותיהם בחירום.",
                "סיוע במתן קדימות למפעלים חיוניים בתחום הרשות המקומית.",
                "הנחיה לפתיחת מפ\"ל (מסגרת פעילות לעובדים חיוניים – שמרטפייה לשעבר) לילדי עובדי הרשות, לאחר אישור ראש הרשות.",
                "העברת הנחיות למתן סיוע ועדיפות בשירותים מוניציפליים לבתי מלון המוגדרים חיוניים."
            ]
        }
    },




]

export default tasksData;








